import { RootState } from '../store'
import { createSelector } from '@reduxjs/toolkit'
import { normalizeGrants } from './utils'

const getGrants = (state: RootState) => state.grants.federal.data
const getLoading = (state: RootState) => state.grants.federal.loading
const getPaging = (state: RootState) => state.grants.federal.paging
const getError = (state: RootState) => state.grants.federal.error

const getFilters = (state: RootState) => state.grants.federal.filters
const getSelectedAgencies = (state: RootState) => state.grants.federal.filters.agencies
const getSelectedPhases = (state: RootState) => state.grants.federal.filters.phases
const getSelectedStatuses = (state: RootState) => state.grants.federal.filters.statuses
const getStartDate = (state: RootState) => state.grants.federal.filters.dates.startDate
const getEndDate = (state: RootState) => state.grants.federal.filters.dates.endDate

const makeFederalGrants = createSelector([getGrants], (grants) => {
  return normalizeGrants(grants)
})

export const FederalSelectors = {
  getGrants,
  getLoading,
  getPaging,
  getError,
  getFilters,
  getSelectedAgencies,
  getSelectedPhases,
  getSelectedStatuses,
  getStartDate,
  getEndDate,
  makeFederalGrants,
}